import { render, staticRenderFns } from "./TkImageSwiper.vue?vue&type=template&id=8f627890&scoped=true&"
import script from "./TkImageSwiper.vue?vue&type=script&lang=js&"
export * from "./TkImageSwiper.vue?vue&type=script&lang=js&"
import style0 from "./TkImageSwiper.vue?vue&type=style&index=0&id=8f627890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f627890",
  null
  
)

export default component.exports